<template>
  <div class="fixed-bottom" v-if="$route.name==='Home'">
    <p>{{userEmail}}</p>
    <button class="btn text-link  mx-auto" @click="logout">
      Logout
    </button>
  </div>
</template>
<script>
export default {
  methods: {
    logout(){
      swal({
        title: "Are you sure?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          this.$axios.delete('logout')
            .then(res => {
              if(res.data.status == true){
                localStorage.removeItem('vt-token');
                localStorage.removeItem('vt-user-name');
                localStorage.removeItem('vt-token');
                this.$router.replace('/login');
                return;
              }
            })
            .catch(err => console.log(err));
        }
      });
    }
  },
  computed: {
    userEmail(){
      return localStorage.getItem('vt-user-email')
    }
  }
}
</script>
